import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';

import '@/tools/libpannellum.js';
import '@/tools/pannellum.js';
import '@/assets/css/pannellum.css';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/icons/SvgIcon.js';
import '@/assets/css/base.less';
import '@/assets/css/style.less';
import '@/assets/css/img-icon.less';
import tools from '@/tools/tools.js';
import TextView from '@/components/TextView';
import ImageView from '@/components/ImageView';
import countTo from 'vue-count-to';


Vue.component("countTo", countTo);
Vue.component('tv', TextView);
Vue.component('iv', ImageView);

Vue.use(ElementUI, {
    size: 'mini',
});

Vue.prototype.$success = (msg) => {
    ElementUI.Message.success({
        dangerouslyUseHTMLString: true,
        message: msg || ""
    });
};
Vue.prototype.$warning = (msg) => {
    ElementUI.Message.warning({
        dangerouslyUseHTMLString: true,
        message: msg || ""
    });
};

Vue.prototype.$info = (msg) => {
    ElementUI.Message.info({
        dangerouslyUseHTMLString: true,
        message: msg || ""
    });
};
Vue.prototype.$error = (msg) => {
    console.error(msg);
    ElementUI.Message.error({
        dangerouslyUseHTMLString: true,
        message: msg || ""
    });
};

Vue.prototype.$t = tools;
Vue.config.productionTip = false;


Vue.mixin({
    computed: {
        date() {
            return this.$t.formatDate(store.getters.date, 'yyyy-MM-dd hh:mm:ss')
        },
        _config(){
            return this.$store.getters.config;
        }
    },
    methods: {
        t(name) {
            let config = this._config;
            if(config && config.hasOwnProperty(name)) {
               return config[name].value;
            }
            return '';
        }
    }
});

store.dispatch('getConfig')
    .then(res => {
        store.dispatch('setLocalConfig', res);
    })
    .catch(e => {
    })

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
